/**
 * Central region configuration
 * Defines all available regions and their properties
 */

// All supported regions
export const ALL_REGIONS = ['de', 'fr', 'es', 'it', 'uk', 'ch', 'at'];

// Regions that support subscriptions
export const SUBSCRIPTION_REGIONS = ['de', 'fr', 'ch', 'at'];

// Regions that do NOT support subscriptions
export const NON_SUBSCRIPTION_REGIONS = ['es', 'it', 'uk'];

/**
 * Check if a region supports subscriptions
 * @param {string} region - Two-letter region code
 * @returns {boolean}
 */
export const isSubscriptionRegion = (region) => {
  return SUBSCRIPTION_REGIONS.includes(region);
};

/**
 * Check if a region is valid
 * @param {string} region - Two-letter region code
 * @returns {boolean}
 */
export const isValidRegion = (region) => {
  return ALL_REGIONS.includes(region);
};

/**
 * Get current region from window.Theme
 * @returns {string|null}
 */
export const getCurrentRegion = () => {
  return window.Theme?.region || null;
};

/**
 * Map region codes to i18n language codes
 * @param {string} region - Two-letter region code
 * @returns {string} - Language code for i18n
 */
export const getLanguageFromRegion = (region) => {
  const regionToLanguage = {
    'de': 'de',
    'fr': 'fr',
    'es': 'es',
    'it': 'it',
    'uk': 'en',
    'ch': 'de', // Switzerland - default to German
    'at': 'de', // Austria - German
  };
  
  return regionToLanguage[region] || 'de';
};

